import * as React from "react";
import DragSortingTable from "./bodyRow"
import { connect } from 'react-redux'
import {Tabs} from "antd";
import {applicationName} from "../utils";
const { TabPane } = Tabs;

 class MyStory  extends React.Component{

    tabs = {
        all : {
            name: "全部",
            url : "/cm-sites-"+applicationName()+"/website/getStoryByColumn",
            type : "all",
        },
        mystory : {
            name: "我的稿件",
            url : "/cm-sites-"+applicationName()+"/website/getStoryByColumn",
            type : "mystory",
        },
        zancun : {
            name: "草稿箱",
            url : "/cm-sites-"+applicationName()+"/website/getStoryByColumn",
            type : "zancun",
        },
        auditing : {
            name: "审核中",
            url : "/cm-sites-"+applicationName()+"/website/getStoryByColumn",
            type : "auditing",
        },
        published : {
            name: "已发布",
            url : "/cm-sites-"+applicationName()+"/website/getStoryByColumn",
            type : "published",
        },
        deprecated : {
            name: "已弃用",
            url : "/cm-sites-"+applicationName()+"/website/getStoryByColumn",
            type : "deprecated",
        },
        revoke : {
            name: "已撤稿",
            url : "/cm-sites-"+applicationName()+"/website/getStoryByColumn",
            type : "revoke",
        }
    };

    state = {
        params: {
            ...this.props.match.params,
            type: "all",
        },
        tabsKey: "all"
    };

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState(prevState => ({
            params: {
                ...prevState.params,
                ...nextProps.match.params,
                type: this.state.tabsKey,
            },
        }));
    }

    renderTabs(){
        let tabComponents = [];
        for(let attr in this.tabs){
            tabComponents.push( <TabPane tab={this.tabs[attr].name} key={attr}>
            </TabPane>)
        }
        return tabComponents.map(item=>item);
    }

    changeTabs(key){
        let  newProps = Object.assign({}, this.props.match.params);
        newProps = Object.assign(newProps, this.tabs[key]);
        this.setState({
            params: {
                ...newProps,
                start: 1,
                size: 10
            },
            tabsKey: key
        })
    }

    render() {
        let newSecondSelectColor = this.props.sysConfig && this.props.sysConfig.getValueByKey ? this.props.sysConfig.getValueByKey("newSecondSelectColor", '#0050B3') : '#0050B3';
        let dragSortingTable = <DragSortingTable params={this.state.params} />;
        return (
            <div style={{backgroundColor:"white",margin:"15px"}}>
                <Tabs className="mystory" defaultActiveKey={"all"} onChange={(key)=>this.changeTabs(key)} activeKey={this.state.tabsKey}>
                    {this.renderTabs()}
                </Tabs>
                <style>
                            {`
                            .mystory{
                                margin-bottom: 20px;
                            }
                          
            .mystory .ant-tabs-bar{
                border: none
            }
            .mystory  .ant-tabs-bar .ant-tabs-tab-active {
              color:${newSecondSelectColor}!important ;
              font-weight:bold !important;
             font-size:16px !important;
                }
                .mystory  .ant-tabs-nav-container  {
             font-size:16px !important;
                }
              .mystory .ant-tabs-ink-bar{
                background-color:  ${newSecondSelectColor} !important;
                }
               .mystory  .ant-tabs-nav .ant-tabs-tab {
               color: #6c748b;
               font-weight:bold !important;
               }
             .mystory  .ant-tabs-nav .ant-tabs-tab:hover {
                color: ${newSecondSelectColor} !important;
            }
                             `}
                        </style>
                {dragSortingTable}
            </div>

        )

    }
}

function mapStateToProps(state) {
    return {
        currentUser: state.systemReducer.currentUser,
        sysConfig: state.systemReducer.config,

    }
}


export default connect(mapStateToProps)(MyStory);